import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface NotificationItem {
  id: string;
  description: string;
  date: Date;
  isReaded: boolean;
  externalId?: string;
  kind: NotificationKind;
}

export enum NotificationKind {
  InvoiceGenerated = 1,
  WhatsAppSent = 2,
  EmailSent = 3,
  DeviceOffline = 4,
  DeviceOnline = 5,
  BillingPending = 6,
  NoCashBoxActive = 7,
  SeriesRangeExhausted = 8,
  ParkingIncident = 9,
  BlacklistRecurrenceSuggestion = 10,
  PassExpired = 11
}

export interface NotificationsResponse {
  success: boolean;
  requestResult: NotificationItem[];
  reason?: string;
}

export interface MarkReadResponse {
  success: boolean;
  requestResult: boolean;
  reason?: string;
}

const INCIDENT_TYPE_LABELS: Record<string, string> = {
  EvasionAnonymous: 'evasión anónima',
  ForcedBarrier: 'barrera forzada',
  ManualOverride: 'anulación manual',
  ToleranceExceeded: 'tolerancia excedida',
  MatchedExitNoCharge: 'salida matcheada sin cobro',
};

/** Normaliza descripciones legacy que guardaron el nombre del enum en inglés. */
export function formatNotificationDescription(description: string): string {
  let result = description;
  for (const [enumName, label] of Object.entries(INCIDENT_TYPE_LABELS)) {
    result = result.replace(enumName, label);
  }
  return result;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private apiUrl = `${environment.apiBaseUrl}/api/v1/notifications`;

  constructor(private http: HttpClient) { }

  getUnreadNotifications(): Observable<NotificationsResponse> {
    return this.http.get<NotificationsResponse>(`${this.apiUrl}/unread`);
  }

  markAsRead(id: string): Observable<MarkReadResponse> {
    return this.http.put<MarkReadResponse>(`${this.apiUrl}/${id}/mark-read`, {});
  }

  markAllAsRead(): Observable<MarkReadResponse> {
    return this.http.put<MarkReadResponse>(`${this.apiUrl}/mark-all-read`, {});
  }
}

